import React, { Fragment } from "react";
import { Tab } from "@headlessui/react";
import { classNames } from "utils/utils";

import { useGame } from "context/gameContext";

const TabItem = ({ title, loading, badge }) => {
  const {
    state: { theme },
  } = useGame();

  let tabBackround = theme?.id === 0 ? "hover:bg-white" : "hover:bg-white/40";
  return (
    <Tab as={Fragment}>
      {({ selected }) => (
        <div
          className={classNames(
            selected
              ? "text-textSecondary bg-textPrimary shadow"
              : "text-black",
            selected ? "" : tabBackround,
            "flex justify-center w-full rounded-lg py-2.5 text-sm font-medium leading-5ring-white ring-opacity-60 focus:outline-none focus:ring-none cursor-pointer"
          )}
        >
          <div className="grid items-center justify-center w-full grid-flow-col">
            <div className="truncate px-2">{title}</div>
          </div>
        </div>
      )}
    </Tab>
  );
};

export default TabItem;
